export default __webpack_public_path__ + "static/media/trybeer1.50c27c06.jpeg";